import { apiClient } from "@/lib/api-client";

export type SyncKinerjaResponse = {
  message: string;
  status: string;
};

export const postSyncKinerja = async (): Promise<SyncKinerjaResponse> => {
  const resData = await apiClient<SyncKinerjaResponse>(
    `/api-cdc/webhook/sync`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "x-api-key": import.meta.env.VITE_API_X_CDC_KEY,
      },
    },
  );

  return resData;
};
